// https://vuex.vuejs.org/en/state.html

export default () => ({
  locale: "",
  me: null,
  signInError: null,
  items: {},
  ads: {},
  payTokenInfo: null
});
